var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useState } from 'react';
import { NewsletterSignupEvent } from '../../enums/Tracking';
import { useGqlLocale } from '../../hooks/locale';
import dispatchTrackingEvent from '../../tracking/dispatchTrackingEvent';
import { FormStateType } from '../SubmitInput';
import { executeSubscribeToNewsletter } from './utils/requests';
import { FormMessage, getValidationError, } from './utils/validation';
import { getTrackingData } from './utils/tracking';
var useNewsletterSubscription = function (_a) {
    var initialState = _a.initialState, initialMessage = _a.initialMessage, initialIsLoading = _a.initialIsLoading, tracking = _a.tracking, submitCallback = _a.onSubmit;
    var locale = useGqlLocale();
    var _b = __read(useState(''), 2), value = _b[0], setValue = _b[1];
    var _c = __read(useState(initialState), 2), state = _c[0], setState = _c[1];
    var _d = __read(useState(initialMessage), 2), message = _d[0], setMessage = _d[1];
    var _e = __read(useState(initialIsLoading), 2), isLoading = _e[0], setIsLoading = _e[1];
    var onChange = useCallback(function (event) {
        setValue(event.target.value);
        setState(FormStateType.Default);
        setMessage(FormMessage.None);
    }, []);
    var subscribeToNewsletter = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, visitorHash, newState, newMessage;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    dispatchTrackingEvent(getTrackingData({
                        event: NewsletterSignupEvent.NewsLetterSignUpClick,
                        tracking: tracking,
                    }));
                    setIsLoading(true);
                    setState(FormStateType.Default);
                    setMessage(FormMessage.None);
                    return [4 /*yield*/, executeSubscribeToNewsletter({ email: value, locale: locale })];
                case 1:
                    _a = _b.sent(), visitorHash = _a.visitorHash, newState = _a.state, newMessage = _a.message;
                    setState(newState);
                    setMessage(newMessage);
                    setIsLoading(false);
                    if (newState === FormStateType.Success) {
                        dispatchTrackingEvent(getTrackingData({
                            event: NewsletterSignupEvent.NewsLetterSignUpSuccess,
                            tracking: tracking,
                            visitorHash: visitorHash,
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [value, tracking, locale]);
    var onSubmit = useCallback(function (event) {
        var errorMessage = getValidationError(event.target);
        if (submitCallback) {
            submitCallback();
        }
        if (errorMessage === null) {
            subscribeToNewsletter();
        }
        else {
            setState(FormStateType.Error);
            setMessage(errorMessage);
        }
    }, [subscribeToNewsletter, submitCallback, state, isLoading]);
    return { onSubmit: onSubmit, onChange: onChange, state: state, message: message, value: value, isLoading: isLoading };
};
export default useNewsletterSubscription;
